import { useLocale } from 'next-intl';
import type { MouseEventHandler } from 'react';

import { EventType } from '@/analytics/types';
import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

const ScienceAndResearchCards = () => {
  const locale = useLocale();
  const localePartialUrl = getLocalePartialUrl(locale);

  const handleCardLinkClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    const { href } = event.currentTarget;
    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'read_more',
      location: 'body',
      path: href,
    });
  };

  return (
    <section data-cy="science-and-research-cards">
      <LandingPageCards
        cards={[
          {
            description: {
              messageKey: 'science_and_research_san_francisco_description',
            },
            id: 'san_francisco',
            image: {
              localizedAlt: 'science_and_research_card_one_alt',
              src: 'blue-sky/science-and-research/ucsf-health',
            },
            link: {
              href: `https://ouraring.com/blog${localePartialUrl}detect-covid-19/`,
              label: 'read_more',
              onClick: handleCardLinkClick,
              target: '_blank',
            },
            title: {
              messageKey: 'science_and_research_san_francisco_title',
            },
          },
          {
            description: {
              messageKey: 'science_and_research_singapore_description',
            },
            id: 'singapore',
            image: {
              localizedAlt: 'science_and_research_or4_card_two_alt',
              src: 'blue-sky/science-and-research/nus-or4',
            },
            link: {
              href: `https://ouraring.com/blog${localePartialUrl}oura-emerges-as-most-accurate-consumer-sleep-wearable/`,
              label: 'read_more',
              onClick: handleCardLinkClick,
              target: '_blank',
            },
            title: {
              messageKey: 'science_and_research_singapore_title',
            },
          },
          {
            description: {
              messageKey: 'science_and_research_san_diego_description',
            },
            id: 'san_diego',
            image: {
              localizedAlt: 'science_and_research_card_three_alt',
              src: 'blue-sky/science-and-research/uc-san-diego-or4',
            },
            link: {
              href: `https://ouraring.com/blog${localePartialUrl}ucsd-pregnancy-study/`,
              label: 'read_more',
              onClick: handleCardLinkClick,
              target: '_blank',
            },
            title: {
              messageKey: 'science_and_research_san_diego_title',
            },
          },
        ]}
      />
    </section>
  );
};

export default ScienceAndResearchCards;
